const fs = require('fs');
const path = require('path');

exports.loadRecordedMock = (fileName) => {
  return JSON.parse(
    fs.readFileSync(
      path.join(__dirname, '../../nock/recorded', fileName),
      'utf8'
    )
  );
};
